const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION as string;
const build_version = BUILD_VERSION ? BUILD_VERSION : '0.0.1';

const en = {
  'return': {
    'home': 'Back To Home',
  },
  'error': {
    'not_found': 'Page Not Found',
    'components': {
      'paramsEmpty': 'params：{reason} can`t be empty',
    }
  },
  'whiteboard': {
    'loading': 'Loading...',
  },
  'toast': {
    'api_login_failured': 'Join Failured, Reason: {reason}',
    'confirm': 'Confirm',
    'cancel': 'Cancel',
    'quit_room': 'Are you sure to exit this session?',
    'kick': 'kicked',
    'login_failure': 'login failure',
    'whiteboard_lock': 'Whiteboard follow',
    'whiteboard_unlock': 'Whiteboard nofollow',
    'canceled_screen_share': 'Canceled screen sharing',
    'screen_sharing_failed': 'Screen sharing failed, reason: {reason}',
    'recording_failed': 'Start cloud recording failed, reason: {reason}',
    'start_recording': 'Start cloud recording success',
    'stop_recording': 'Stop cloud recording success',
    'recording_too_short': 'Recording too short, at least 15 seconds',
    'rtm_login_failed': 'login failure, please check your network',
    'rtm_login_failed_reason': 'login failure, reason: {reason}',
    'replay_failed': 'Replay Failed please refresh browser',
    'teacher_exists': 'Speakeralready exists, Please waiting for 30s or reopen new session',
    'student_over_limit': 'Attendees have reached upper limit, , Please waiting for 30s or rejoin new session',
    'teacher_and_student_over_limit': 'The number of Attendees and Speakerhave reached upper limit',
    'teacher_accept_whiteboard': 'Speakeralready grant your whiteboard',
    'teacher_cancel_whiteboard': 'Speakeralready cancel your whiteboard',
    'teacher_accept_co_video': 'Speakeralready accept co-video',
    'teacher_reject_co_video': 'Speakeralready rejected co-video',
    'teacher_cancel_co_video': 'Speakeralready canceled co-video',
    'student_cancel_co_video': 'Attendee canceled co-video',
    'email_exists': 'The email has already been taken.',
    'invalid_code': 'Invalid Code',
    'something_went_wrong': 'Something went wrong, try again!',
    'code_send': 'Code send successfully!',
    'wrong_email_or_password': 'Wrong email or password!',
    'newPasswordWrong': 'New password and confirm password should be matched!',
    'room_not-working': 'This rome is expired',
    'emailSent': "Please check your email",
    'passwordChanged': 'Password has changed successfully!',
    'currentPasswordIsWrong': 'Current password is wrong!',
    'wrong_email': 'Wrong email',
    'dataSaved': 'Data saved successfully',
    'codeActivatedSuccessfully': 'Code activated successfully',
    'correctPassword': 'Correct password',
    'wrongRoomName': 'Trying to enter non existing room',
    'inActiveRoom': 'trying to enter inactive room',
    'passwordIsWrong': 'Something went wrong, try again!',
    'userBlocked': 'Your account is not active, please contact your system admin.',
    'passwordsDontMatch': 'Passwords should be matched!'
  },
  'notice': {
    'student_interactive_apply': `"{reason}" wants to interact with you`
  },
  'chat': {
    'placeholder': 'Chat',
    'banned': 'Banned',
    'send': 'send'
  },
  'device': {
    'camera': 'Camera',
    'microphone': 'Microphone',
    'speaker': 'Speaker',
    'finish': 'Save',
  },
  'nav': {
    'delay': 'Delay: ',
    'network': 'Network: ',
    'cpu': 'CPU: ',
    'class_end': 'End',
    'class_start': 'Start'
  },



  'home': {
    'entry-home': 'Join Session',
    'teacher': 'Group Admin',
    'student': 'Attendee',
    'cover_class': 'cover-en',
    'room_name': 'Room Name',
    'nickname': 'Your Name',
    'room_type': 'Room Type',
    'room_join': 'Join',
    'short_title': {
      'title': 'iHR Meet',
      'subtitle': 'Powered by iHR, a leading online learning engagement platform',
    },
    'name_too_long': 'name too long, should <= 20 characters',
    '1v1': 'One to One',
    'mini_class': 'Small Group',
    'meet_class': 'Meet Group',
    'large_class': 'Large Group',
    'missing_room_name': 'Missing room name',
    'missing_your_name': 'missing your name',
    'missing_password': 'missing password',
    'missing_role': 'missing role',
    'account': 'nickname',
    'password': 'password',
    "wrong_room_name": "Wrong room name!",
    "theSessionIsOld": "Session is old!",
    "missing_code": "Missing code",
    'missingPassword': 'Missing password',
    'missingConfirmPassword': 'Missing confirm password',
    'missingName': 'Missing name',
    'missingPhone': 'Missing phone',
    'wrongPassword': 'Wrong password',
    'wrongRoomName': 'Trying to enter non existing room',
    'missingField': 'Missing field',
    'joinRoomRole': 'Missing role'
  },
  'room': {
    'chat_room': 'Chat',
    'student_list': 'Attendees',
    'uploading': 'Uploading...',
    'converting': 'Converting...',
    'upload_success': 'upload success',
    'upload_failure': 'upload failure, check the network',
    'convert_success': 'convert success',
    'convert_failure': 'convert failure, check the network',
  },
  'replay': {
    'loading': 'loading...',
  },
  'build_version': `build version: ${build_version}`,
  'login': 'Login',
  'email': 'Email',
  'password': 'Password',
  'fullName': 'Full name',
  'register': 'Register',
  'forgetPassword': 'Forgot password?',
  'signIn': 'Sign in',
  'send': 'Send',
  'name': 'Name',
  'country': 'Country',
  'mobile': 'Mobile number',
  'join2': 'Join',
  'register_new_account': 'Join Us',
  'requiredField': 'Required field',
  'enterCorrectEmailFormat': 'Please enter correct email format',
  'passwordLength': 'Password must be 6 characters',
  'confirm_terms_conditions': 'I Have read & agreed to the',
  'terms_conditions': ' Terms of use',
  'areYouSureToLogOut': 'Are you sure you want to logout?',
  'logout': 'Logout',
  'close': 'Close',
  'personalId': 'ID',
  'sendInvitation': 'Invite Someone',
  'start': 'Start Meeting',
  'roomName': 'Room name',
  'joinRoom': 'Join Room',
  'join': 'Join',
  'student': 'Attendee',
  'teacher': 'Group Admin',
  'editProfile': 'Edit Profile',
  'changePassword': 'Change Password',
  'save': 'Save',
  'currentPassword': 'Current password',
  'newPassword': 'New password',
  'confirmPassword': 'Confirm password',
  'update': 'Update',
  'linkCopied': 'Link Copied!',
  'activation_code': 'activation Code',
  'enter_code': 'Enter code here',
  'pleaseInsertActivationCode': 'Please insert the activation code',
  'toActivateYourAccount': 'to activate your account',
  'activate': 'Activate',
  'reSendCode': 'Resend activation code',
  'mobileMsg': 'In order to join the meeting, please either open the link form a computer or install the app from the links below.',
  'newConfirmationPass': 'New Password Confirmation',
  'submit': 'Submit',
  'settings': 'Settings',
  'shareLink': 'Share Link',
  'roomPassword': 'Room Password',
  'adminPassword': 'Admin Password',
  'connectPeople': 'connecting people',
  'or': 'Or',
  'joinMeeting': 'Or join a meeting via room name',
  'exit': 'Exit',
  'roomCopied': 'Room copied!',
  'welcome': 'Welcome',
  'allFieldsRequired': 'All fields are required',
  'forgotPassword': 'Forgot password',
  'share_screen': 'Share screen',
  'members': 'Members',
  'share_your_screen': 'Share Your Screen'
}

export default en;